<template>
  <div>
    <!-- Hero Section -->
    <div class="hero-section position-relative">
      <div class="hero-overlay"></div>
      <div class="hero-image-container">
        <img src="@/assets/porto-service.jpg" alt="Porto Service" class="hero-image">
      </div>
      <div class="container-fluid px-4 h-100">
        <div class="row h-100 align-items-center">
          <div class="col-12 text-center text-white position-relative">
            <h1 class="display-2 fw-bold mb-4">Hammer Serviços Navais</h1>
            <p class="lead mb-4">Excelência e inovação em serviços navais</p>
            <router-link to="/servicos" class="btn btn-primary btn-lg">
              Conheça Nossos Serviços
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Valores Section -->
    <div class="bg-light py-4">
      <div class="container-fluid px-4">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <h2 class="display-4">Missão | Visão | Valores</h2>
            <p class="lead">Pilares que guiam nossa atuação</p>
          </div>
        </div>
        <div class="py-4">
      <div class="container-fluid px-4">
        <div class="row g-4">
          <div class="col-lg-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-5 text-center">
                <div class="mb-4">
                  <i class="bi bi-flag text-primary display-4"></i>
                </div>
                <h2 class="h3 mb-4">Nossa Missão</h2>
                <p class="mb-0">Contribuir em parceria com os
                      nossos clientes para o
                      desenvolvimento perene da
                      indústria naval brasileira.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-5 text-center">
                <div class="mb-4">
                  <i class="bi bi-eye text-primary display-4"></i>
                </div>
                <h2 class="h3 mb-4">Nossa Visão</h2>
                <p class="mb-0">Ser uma empresa de referência
                                na indústria naval com foco na
                                tecnologia, desenvolvimento e
                                sustentabilidade.</p>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card h-100 border-0 shadow-sm">
              <div class="card-body p-5 text-center">
                <div class="mb-4">
                  <i class="bi bi-award text-primary display-4"></i>
                </div>
                <h2 class="h3 mb-4">Nossos Valores</h2>
                <p class="mb-0">Excelência, comprometimento,
                                adaptabilidade, foco,
                                integridade, honestidade,
                                transparência, segurança,
                                qualidade e dedicação.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


        <!-- <div class="row justify-content-center g-4">
          <div class="col-md-4">
            <div class="card h-100 shadow-sm border-0 rounded-4 p-4 text-center">
              <div class="mb-4">
                <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' fill='none' stroke='#0d2233' stroke-width='4' viewBox='0 0 48 48'><path d='M10 8v32M10 10h20l-2 6 2 6H10'/></svg>
              </div>
              <h3 class="fw-bold mb-3">Nossa Missão</h3>
              <p>Contribuir em parceria com os nossos clientes para o desenvolvimento perene da indústria naval brasileira.</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card h-100 shadow-sm border-0 rounded-4 p-4 text-center">
              <div class="mb-4">
                <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' fill='none' stroke='#0d2233' stroke-width='4' viewBox='0 0 48 48'><ellipse cx='24' cy='24' rx='16' ry='10'/><circle cx='24' cy='24' r='4'/></svg>
              </div>
              <h3 class="fw-bold mb-3">Nossa Visão</h3>
              <p>Ser uma empresa de referência na indústria naval com foco na tecnologia, desenvolvimento e sustentabilidade. Visão Excelência, comprometimento, adaptabilidade, foco, integridade, honestidade, transparência, segurança, qualidade e dedicação</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card h-100 shadow-sm border-0 rounded-4 p-4 text-center">
              <div class="mb-4">
                <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' fill='none' stroke='#0d2233' stroke-width='4' viewBox='0 0 48 48'><ellipse cx='24' cy='24' rx='16' ry='10'/><circle cx='24' cy='24' r='8'/></svg>
              </div>
              <h3 class="fw-bold mb-3">Nossos Valores</h3>
              <p>Excelência, comprometimento, adaptabilidade, foco, integridade, honestidade, transparência, segurança, qualidade e dedicação.</p>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- Serviços Preview Section -->
    <div class="py-3">
      <div class="container-fluid px-4">
        <div class="row mb-5">
          <div class="col-12 text-center">
            <h2 class="display-4">Nossos Serviços</h2>
            <p class="lead">Soluções completas em serviços navais</p>
          </div>
        </div>

        <div class="row g-5 justify-content-center">
          <div class="col-lg-5">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-img-wrapper">
                <img src="@/assets/estaleiro.png" class="card-img-top" alt="Manutenção Naval">
                <div class="card-img-overlay d-flex align-items-center justify-content-center">
                  <h3 class="text-white text-center">Manutenção Naval</h3>
                </div>
              </div>
              <div class="card-body p-5">
                <p class="card-text mb-4">
                  Serviços especializados em construção, manutenção e reparo de embarcações 
                  em geral garantindo a segurança, qualidade e eficiência das operações.
                </p>
                <router-link to="/servicos" class="btn btn-outline-primary">
                  Saiba Mais
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-lg-5">
            <div class="card border-0 shadow-sm h-100">
              <div class="card-img-wrapper">
                <img src="@/assets/engenharia-naval.png" class="card-img-top" alt="Engenharia Naval">
                <div class="card-img-overlay d-flex align-items-center justify-content-center">
                  <h3 class="text-white text-center">Engenharia Naval</h3>
                </div>
              </div>
              <div class="card-body p-5">
                <p class="card-text mb-4">
                  Soluções em engenharia e projetos navais, desenvolvendo soluções inovadoras 
                  para o setor.
                </p>
                <router-link to="/servicos" class="btn btn-outline-primary">
                  Saiba Mais
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center py-3">
      <router-link to="/servicos" class="btn btn-primary">Conheça nossos serviços</router-link>
    </div>

    <!-- CTA Section -->
    <!-- <div class="text-white">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="col-lg-8">
            <h2 class="h2 mb-3">Precisa de nossos serviços?</h2>
            <p class="lead mb-0">Entre em contato conosco para mais informações</p>
          </div>
          <div class="col-lg-4 text-lg-end mt-4 mt-lg-0">
            <router-link to="/trabalhe-conosco" class="btn btn-light btn-lg px-5 py-3">
              Solicitar Orçamento
            </router-link>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
.hero-section {
  height: 80vh;
  min-height: 600px;
  overflow: hidden;
}

.hero-image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transform: scale(1.1);
  animation: zoomEffect 20s infinite alternate ease-in-out;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.4)
  );
  z-index: 1;
}

.container-fluid {
  position: relative;
  z-index: 2;
}

@keyframes zoomEffect {
  from {
    transform: scale(1.1);
  }
  to {
    transform: scale(1.2);
  }
}

.card-img-wrapper {
  position: relative;
  overflow: hidden;
  height: 400px;
}

.card-img-top {
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.card:hover .card-img-top {
  transform: scale(1.05);
}

.card-img-overlay {
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.card:hover .card-img-overlay {
  opacity: 1;
}

.card-img-overlay h3 {
  font-size: 2.5rem;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

.btn {
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.py-6 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

/* Ajustes responsivos */
@media (max-width: 991.98px) {
  .hero-section {
    height: 70vh;
    min-height: 500px;
  }

  .display-2 {
    font-size: 3rem;
  }

  .display-4 {
    font-size: 2.5rem;
  }

  .lead {
    font-size: 1.1rem;
  }

  .card-img-wrapper {
    height: 300px;
  }

  .card-img-overlay h3 {
    font-size: 2rem;
  }

  .card-body {
    padding: 2rem !important;
  }

  .btn-lg {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
  }
}

@media (max-width: 767.98px) {
  .hero-section {
    height: 60vh;
    min-height: 400px;
  }

  .hero-section h1 {
    font-size: 2.5rem;
  }
  
  .hero-section .lead {
    font-size: 1.1rem;
  }

  .card-img-wrapper {
    height: 250px;
  }

  .card-img-overlay h3 {
    font-size: 1.75rem;
  }

  .py-6 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .text-lg-end {
    text-align: center !important;
  }
}
</style> 